import React from "react"

const Header = () => (
  <div className="privacy-policy-header">
    <div>
      <p className="privacy-policy-content-text">
        This privacy policy applies to the processing activities of Kaizen (as
        defined below). As part of our day-to-day business we need to collect
        personal information from our customers and potential customers to
        ensure that we can meet their needs and provide them with information
        about our services. Your privacy is important to us and it is our policy
        to respect the confidentiality of information and the privacy of
        individuals.
      </p>
      <p className="privacy-policy-content-text">
        Any personal information we hold will be governed by our most current
        privacy notice.
      </p>
    </div>
    <div className="privacy-policy-header-divider" />
    <div>
      <p className="privacy-policy-content-text">
        This policy outlines how we manage your personal information supplied to
        us by you or a third party in connection with our provision of services
        to you or which we collect from your use of our services and/or
        website(s). It also details your rights in respect of our processing of
        your personal information. Our privacy policy will be reviewed from time
        to time to take account of new obligations and technology, changes to
        our operations and practices and to make sure it remains appropriate to
        the changing environment.
      </p>
    </div>
  </div>
)

export default Header
